import React, {useEffect, useState} from 'react'
import {
  getMemberPublicCategories,
  PublicMemberCategory,
} from '../../../services/memberCategoriesService'
import {orderedPublicCategories} from '../utils/memberCategories'

/**
 * WP-T5 — render a member's PUBLIC (staff-confirmed) categories on their profile. Primary category
 * first and highlighted. Unconfirmed/proposed selections are never shown (backend returns confirmed
 * only). Renders nothing when there are none.
 *
 * ⚠️ BLOCKED ON TAXONOMY BACKEND DEPLOY: reads /taxonomy/members/<id>/categories/ (not deployed yet),
 * so this quietly renders nothing until the backend is live.
 */
const MemberCategoryChips: React.FC<{userId?: number | string}> = ({userId}) => {
  const [categories, setCategories] = useState<PublicMemberCategory[]>([])

  useEffect(() => {
    let mounted = true
    if (!userId) {
      setCategories([])
      return
    }
    getMemberPublicCategories(userId)
      .then((data) => {
        if (mounted) setCategories(orderedPublicCategories(data))
      })
      .catch(() => {
        if (mounted) setCategories([])
      })
    return () => {
      mounted = false
    }
  }, [userId])

  if (categories.length === 0) return null

  return (
    <div className='member-category-chips'>
      {categories.map((c) => (
        <span
          key={c.id}
          className={`member-category-chips__chip ${
            c.isPrimary ? 'member-category-chips__chip--primary' : ''
          }`}
        >
          {c.name}
        </span>
      ))}
    </div>
  )
}

export default MemberCategoryChips
